import { Money } from "@app/class/money";

export enum APPORTIONMENT_CODE {
    ROUND_AUTO_FIRST = 1,
    ROUND_AUTO_FIRST_ONE,
    ROUND_AUTO_LAST_ONE,
    ROUND_AUTO_LAST,
    ROUND_DOWN_FIRST,
    ROUND_DOWN_FIRST_ONE,
    ROUND_DOWN_LAST_ONE,
    ROUND_DOWN_LAST,
    ROUND_UP_FIRST,
    ROUND_UP_FIRST_ONE,
    ROUND_UP_LAST_ONE,
    ROUND_UP_LAST,
    ABNT_FIRST,
    ABNT_FIRST_ONE,
    ABNT_LAST_ONE,
    ABNT_LAST
}


export type RoundType = "round" | "ceil" | "floor" | "ABNT";
export const ROUND_MODES: { type: RoundType, label: string }[] = [
    {
        type: "round",
        label: "Automático"
    },
    {
        type: "ceil",
        label: "para cima"
    },
    {
        type: "floor",
        label: "para baixo"
    },
    {
        type: "ABNT",
        label: "ABNT"
    }
];

interface Apportionment {
    code: APPORTIONMENT_CODE;
    label: string,
    rule?: string,
    roundTo: "auto" | "up" | "down" | "abnt",
    distributeTo: "first" | "firstOne" | "lastOne" | "last",
    roundMode: RoundType,
    title: string,
    example: string
}

export const APPORTIONMENTS: Apportionment[] = [
    {
        code: APPORTIONMENT_CODE.ROUND_AUTO_FIRST,
        label: "Automático e corrige nas primeiras",
        rule: "Se a terceira casa decimal for igual ou maior que 5, arredonda a segunda casa decimal para cima.",
        roundTo: "auto",
        roundMode: "round",
        distributeTo: "first",
        title: 'As primeiras parcelas ficam com valor diferente',
        example: "R$100,00 ÷ 7 = (4 × R$14,29) + (3 × R$14,28)"
    },
    {
        code: APPORTIONMENT_CODE.ROUND_AUTO_FIRST_ONE,
        label: "Automático e corrige  na primeira",
        rule: "Se a terceira casa decimal for igual ou maior que 5, arredonda a segunda casa decimal para cima.",
        roundTo: "auto",
        roundMode: "round",
        distributeTo: "firstOne",
        title: 'A primeira parcela fica com valor diferente',
        example: "R$100,00 ÷ 7 = (1 × R$14,32) + (6 × R$14,28)"
    },
    {
        code: APPORTIONMENT_CODE.ROUND_AUTO_LAST_ONE,
        label: "Automático e corrige na última",
        rule: "Se a terceira casa decimal for igual ou maior que 5, arredonda a segunda casa decimal para cima.",
        roundTo: "auto",
        roundMode: "round",
        distributeTo: "lastOne",
        title: 'A última parcela fica com o valor diferente',
        example: "R$100,00 ÷ 7 = (6 × R$14,28) + (1 × R$14,32)",
    },
    {
        code: APPORTIONMENT_CODE.ROUND_AUTO_LAST,
        label: "Automático e corrige nas últimas",
        rule: "Se a terceira casa decimal for igual ou maior que 5, arredonda a segunda casa decimal para cima.",
        roundTo: "auto",
        roundMode: "round",
        distributeTo: "last",
        title: 'As últimas parcelas ficam com valor diferente',
        example: "R$100,00 ÷ 7 = (3 × R$14,28) + (4 × R$14,29)"
    },
    {
        code: APPORTIONMENT_CODE.ROUND_DOWN_FIRST,
        label: "Trunca e soma nas primeiras",
        rule: "A segunda casa decimal é mantida independentemente do valor da terceira casa decimal.",
        roundTo: "down",
        roundMode: "floor",
        distributeTo: "first",
        title: 'As primeiras parcelas ficam com valor maior',
        example: "R$100,00 ÷ 7 = (4 × R$14,29) + (3 × R$14,28)"
    },
    {
        code: APPORTIONMENT_CODE.ROUND_DOWN_FIRST_ONE,
        label: "Trunca e soma na primeira",
        rule: "A segunda casa decimal é mantida independentemente do valor da terceira casa decimal.",
        roundTo: "down",
        roundMode: "floor",
        distributeTo: "firstOne",
        title: 'A primeira parcela fica com valor maior',
        example: "R$100,00 ÷ 7 = (1 × R$14,32) + (6 × R$14,28)"
    },
    {
        code: APPORTIONMENT_CODE.ROUND_DOWN_LAST_ONE,
        label: "Trunca e soma na última",
        rule: "A segunda casa decimal é mantida independentemente do valor da terceira casa decimal.",
        roundTo: "down",
        roundMode: "floor",
        distributeTo: "lastOne",
        title: 'A última parcela fica com o valor maior',
        example: "R$100,00 ÷ 7 = (6 × R$14,28) + (1 × R$14,32)"
    },
    {
        code: APPORTIONMENT_CODE.ROUND_DOWN_LAST,
        label: "Trunca e soma nas últimas",
        rule: "A segunda casa decimal é mantida independentemente do valor da terceira casa decimal.",
        roundTo: "down",
        roundMode: "floor",
        distributeTo: "last",
        title: 'As últimas parcelas ficam com valor maior',
        example: "R$100,00 ÷ 7 = (3 × R$14,28) + (4 × R$14,29)"
    },
    {
        code: APPORTIONMENT_CODE.ROUND_UP_FIRST,
        label: "Arredonda para cima e subtrai nas primeiras",
        rule: "Se a terceira casa decimal for diferente de zero, a segunda casa decimal é arredondada para cima.",
        roundTo: "up",
        roundMode: "ceil",
        distributeTo: "first",
        title: 'As primeiras parcelas ficam com valor menor',
        example: "R$100,00 ÷ 7 = (3 × R$14,28) + (4 × R$14,29)"
    },
    {
        code: APPORTIONMENT_CODE.ROUND_UP_FIRST_ONE,
        label: "Arredonda para cima e subtrai na primeira",
        rule: "Se a terceira casa decimal for diferente de zero, a segunda casa decimal é arredondada para cima.",
        roundTo: "up",
        roundMode: "ceil",
        distributeTo: "firstOne",
        title: 'A primeira parcela fica com valor menor',
        example: "R$100,00 ÷ 7 = (1 × R$14,26) + (6 × R$14,29)"
    },
    {
        code: APPORTIONMENT_CODE.ROUND_UP_LAST_ONE,
        label: "Arredonda para cima e subtrai na última",
        rule: "Se a terceira casa decimal for diferente de zero, a segunda casa decimal é arredondada para cima.",
        roundTo: "up",
        roundMode: "ceil",
        distributeTo: "lastOne",
        title: 'A última parcela fica com o valor menor',
        example: "R$100,00 ÷ 7 = (6 × R$14,29) + (1 × R$14,26)"
    },
    {
        code: APPORTIONMENT_CODE.ROUND_UP_LAST,
        label: "Arredonda para cima e subtrai nas últimas",
        rule: "Se a terceira casa decimal for diferente de zero, a segunda casa decimal é arredondada para cima.",
        roundTo: "up",
        roundMode: "ceil",
        distributeTo: "last",
        title: 'As últimas parcelas ficam com valor menor',
        example: "R$100,00 ÷ 7 = (4 × R$14,29) + (3 × R$14,28)"
    },
    {
        code: APPORTIONMENT_CODE.ABNT_FIRST,
        label: "Arredonda para o número par mais próximo (ABNT) e corrige nas primeiras",
        rule: "Se a terceira casa decimal for igual a 5 e as posteriores forem iguais a 0, arredonda a segunda casa decimal para o número par mais próximo.",
        roundTo: "abnt",
        roundMode: "ABNT",
        distributeTo: "first",
        title: 'As últimas parcelas ficam com valor corrigido',
        example: "R$100,00 ÷ 7 = (4 × R$14,29) + (3 × R$14,28)"
    },
    {
        code: APPORTIONMENT_CODE.ABNT_FIRST_ONE,
        label: "Arredonda para o número par mais próximo (ABNT) e corrige na primeira",
        rule: "Se a terceira casa decimal for igual a 5 e as posteriores forem iguais a 0, arredonda a segunda casa decimal para o número par mais próximo.",
        roundTo: "abnt",
        roundMode: "ABNT",
        distributeTo: "firstOne",
        title: 'A primeira parcela fica com o valor corrigido',
        example: "R$100,00 ÷ 7 = (1 × R$14,30) + (6 × R$14,28)"
    },
    {
        code: APPORTIONMENT_CODE.ABNT_LAST_ONE,
        label: "Arredonda para o número par mais próximo (ABNT) e corrige na última",
        rule: "Se a terceira casa decimal for igual a 5 e as posteriores forem iguais a 0, arredonda a segunda casa decimal para o número par mais próximo.",
        roundTo: "abnt",
        roundMode: "ABNT",
        distributeTo: "lastOne",
        title: 'A última parcela fica com o valor corrigido',
        example: "R$100,00 ÷ 7 = (6 × R$14,28) + (1 × R$14,30)"
    },
    {
        code: APPORTIONMENT_CODE.ABNT_LAST,
        label: "Arredonda para o número par mais próximo (ABNT) e corrige nas últimas",
        rule: "Se a terceira casa decimal for igual a 5 e as posteriores forem iguais a 0, arredonda a segunda casa decimal para o número par mais próximo.",
        roundTo: "abnt",
        roundMode: "ABNT",
        distributeTo: "last",
        title: 'As últimas parcelas ficam com o valor corrigido',
        example: "R$100,00 ÷ 7 = (3 × R$14,28) + (4 × R$14,30)"
    }
];

type RateioParams<T> = {
    array: Array<T>,
    expectedSum: number,
    property: keyof T
}

export class Rateio<T extends object> {

    private readonly _array: RateioParams<T>['array'];
    private readonly _expectedSum: RateioParams<T>['expectedSum'];
    private readonly _property: RateioParams<T>['property'];

    constructor(params: RateioParams<T>) {
        this._array = params.array;
        this._expectedSum = params.expectedSum;
        this._property = params.property;
    }

    private _getValue(item: T): number {
        return parseFloat(item[this._property] as string);
    }

    private _getSum(array: Array<T>): number {
        return array.reduce((sum, item) => sum + this._getValue(item), 0);
    }

    private _getDifference(array: Array<T>): number {
        return parseFloat((this._expectedSum - this._getSum(array)).toFixed(2));
    }

    private _setValue(item: T, newValue: number): void {
        item[this._property] = newValue as any;
    }

    private _getWeight() {
        const difference = this._getDifference(this._array);
        const cents = Math.ceil(difference * 100);
        const centsPerItem = cents / this._array.length;
        if (Math.abs(centsPerItem) > 1) {
            return Number((centsPerItem / 100).toFixed(2));
        }
        return difference > 0 ? 0.01 : -0.01;
    }

    private _getCopy() {
        return structuredClone(this._array);
    }

    private _distributiveFirst(): Array<T> {
        const copy = this._getCopy();
        const weight = this._getWeight();
        for (let i = 0; i < copy.length && Math.abs(this._getDifference(copy)) > 0; i++) {
            const item = structuredClone(copy[i]);
            const currentValue = this._getValue(item);
            this._setValue(item, parseFloat((currentValue + weight).toFixed(2)));
            copy[i] = item;
        }
        return copy;
    }

    private _distributiveLast(): Array<T> {
        const copy = this._getCopy();
        const weight = this._getWeight();
        for (let i = copy.length - 1; i >= 0 && Math.abs(this._getDifference(copy)) > 0; i--) {
            const item = structuredClone(copy[i]);
            const currentValue = this._getValue(item);
            this._setValue(item, parseFloat((currentValue + weight).toFixed(2)));
            copy[i] = item;
        }
        return copy;
    }

    private _first(): Array<T> {
        const copy = this._getCopy();
        const difference = this._getDifference(copy);
        if (copy.length > 1 && Math.abs(difference) >= 0.01) {
            const item = structuredClone(copy[0]);
            const currentValue = this._getValue(item);
            this._setValue(item, parseFloat((currentValue + difference).toFixed(2)));
            copy[0] = item;
        }
        return copy;
    }

    private _last(): Array<T> {
        const copy = this._getCopy();
        const difference = this._getDifference(copy);
        if (copy.length > 1 && Math.abs(difference) >= 0.01) {
            const item = structuredClone(copy[copy.length - 1]);
            const currentValue = this._getValue(item);
            this._setValue(item, parseFloat((currentValue + difference).toFixed(2)));
            copy[copy.length - 1] = item;
        }
        return copy;
    }

    apportion(apportionment: APPORTIONMENT_CODE): Array<T> {
        switch (apportionment) {
            case APPORTIONMENT_CODE.ROUND_UP_FIRST_ONE:
            case APPORTIONMENT_CODE.ROUND_DOWN_FIRST_ONE:
                return this._first();
            case APPORTIONMENT_CODE.ROUND_UP_LAST_ONE:
            case APPORTIONMENT_CODE.ROUND_DOWN_LAST_ONE:
                return this._last();
            case APPORTIONMENT_CODE.ROUND_UP_LAST:
            case APPORTIONMENT_CODE.ROUND_DOWN_LAST:
                return this._distributiveLast();
            case APPORTIONMENT_CODE.ROUND_UP_FIRST:
            case APPORTIONMENT_CODE.ROUND_DOWN_FIRST:
            default:
                return this._distributiveFirst();
        }
    }

    test(): {
        table: {
            original: number,
            first: number,
            firstOne: number,
            lastOne: number,
            last: number,
        }[],
        defaultValue: number,
        difference: number
    } {
        const table = [];
        const primeira = this._first();
        const primeiras = this._distributiveFirst();
        const ultima = this._last();
        const ultimas = this._distributiveLast();

        for (let i = 0; i < this._array.length; i++) {
            table.push({
                original: this._getValue(this._array[i]),
                first: this._getValue(primeiras[i]),
                firstOne: this._getValue(primeira[i]),
                lastOne: this._getValue(ultima[i]),
                last: this._getValue(ultimas[i])
            })
        }
        const defaultValue = this._getValue(ultima[0]);
        const difference = this._getDifference(this._array);

        return {
            table,
            defaultValue,
            difference
        }
    }
}
